import { Box } from "@material-ui/core";
import { useTtmsAuth } from "@tt/ttms-react-core";
import * as React from "react";
import { useRedirect } from "react-admin";

// function isValidUrl(string) {
//   try {
//     const url = new URL(string);
//     return url.protocol === "https:";
//   } catch (_) {
//     return false;
//   }
// }

// function getVideoLink() {
//   let videoLink = localStorage.getItem("showVideos");
//   videoLink = "http://localhost:3000/#/videos/100001/show";
//   if (videoLink != null) {
//     if (isValidUrl(videoLink)) {
//       window.location.replace(videoLink);
//     } else {
//       console.warn("Invalid video link detected:", videoLink);
//     }
//     localStorage.removeItem("showVideos");
//     return null;
//   }
// }

const AuthorizedCheck = (props) => {
  const { user } = useTtmsAuth();
  const redirect = useRedirect();

  if (user == null) {
    redirect("/login");
  } else {
    // getVideoLink();

    if (!user?.can("safebook.admin") && props.isAdmin === true) {
      return (
        <React.Fragment>
          <Box mt={{ xs: 0, lg: "8em" }} textAlign={"center"} border={0}>
            You are not authorized to view this page.
          </Box>
        </React.Fragment>
      );
    }

    return <div>{props.children}</div>;
  }

  return null;
};

export default AuthorizedCheck;
